export class TimelineItem {
  constructor({ date, type }) {
    this.date = date;
    this.type = type;
  }
}


// WEBPACK FOOTER //
// ./src/fossil/timeline_item.js